import React, { Component } from "react";
import { withTranslation } from 'react-i18next';

// import flag images as needed
// import usFlag from "../../../assets/images/flags/us.jpg";
// import spain from "../../../assets/images/flags/spain.jpg";
// import germany from "../../../assets/images/flags/germany.jpg";
// import italy from "../../../assets/images/flags/italy.jpg";
// import russia from "../../../assets/images/flags/russia.jpg";

class LanguageDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: false,
      lng: "English",
      // flag: usFlag
    };
    this.toggle = this.toggle.bind(this);
    // this.changeLanguageAction = this.changeLanguageAction.bind(this);
  }

  toggle() {
    this.setState(prevState => ({
      menu: !prevState.menu
    }));
  }

  // Uncomment and update flag logic as needed
  // changeLanguageAction = (lng) => {
  //   i18n.changeLanguage(lng);
  //   if (lng === "sp") this.setState({ lng: "Spanish", flag: spain });
  //   else if (lng === "gr") this.setState({ lng: "German", flag: germany });
  //   else if (lng === "rs") this.setState({ lng: "Russian", flag: russia });
  //   else if (lng === "it") this.setState({ lng: "Italian", flag: italy });
  //   else if (lng === "eng") this.setState({ lng: "English", flag: usFlag });
  // }

  render() {
    return (
      <React.Fragment>
        <div className="dropdown d-none d-sm-inline-block">
          <button
            type="button"
            className="btn header-item waves-effect"
            id="page-header-lang-dropdown"
            onClick={this.toggle}
            aria-expanded={this.state.menu}
            aria-haspopup="true"
          >
            {/* <img className="" src={this.state.flag} alt="Header Language" height="16" /> */}
            <span className="align-middle">{this.state.lng}</span>
          </button>
          <div
            className={`dropdown-menu dropdown-menu-end${this.state.menu ? " show" : ""}`}
            aria-labelledby="page-header-lang-dropdown"
          >
            {/* Uncomment and update flag logic as needed */}
            {/* <button className={`dropdown-item notify-item${this.state.lng === "English" ? " active" : ""}`} onClick={() => this.changeLanguageAction('eng')}>
              <img src={usFlag} alt="user" className="me-1" height="12" /> <span className="align-middle">English</span>
            </button>
            <button className={`dropdown-item notify-item${this.state.lng === "Spanish" ? " active" : ""}`} onClick={() => this.changeLanguageAction('sp')}>
              <img src={spain} alt="user" className="me-1" height="12" /> <span className="align-middle">Spanish</span>
            </button>
            <button className={`dropdown-item notify-item${this.state.lng === "German" ? " active" : ""}`} onClick={() => this.changeLanguageAction('gr')}>
              <img src={germany} alt="user" className="me-1" height="12" /> <span className="align-middle">German</span>
            </button>
            <button className={`dropdown-item notify-item${this.state.lng === "Italian" ? " active" : ""}`} onClick={() => this.changeLanguageAction('it')}>
              <img src={italy} alt="user" className="me-1" height="12" /> <span className="align-middle">Italian</span>
            </button>
            <button className={`dropdown-item notify-item${this.state.lng === "Russian" ? " active" : ""}`} onClick={() => this.changeLanguageAction('rs')}>
              <img src={russia} alt="user" className="me-1" height="12" /> <span className="align-middle">Russian</span>
            </button> */}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(LanguageDropdown);
